import { render, staticRenderFns } from "./ShiftSegmentItem.vue?vue&type=template&id=31b59f5e&scoped=true&"
import script from "./ShiftSegmentItem.vue?vue&type=script&lang=js&"
export * from "./ShiftSegmentItem.vue?vue&type=script&lang=js&"
import style0 from "./ShiftSegmentItem.vue?vue&type=style&index=0&id=31b59f5e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31b59f5e",
  null
  
)

export default component.exports